module.exports = __webpack_public_path__ + "media/images/icon-benefits-mybenefits-1f829fc1e05a2109c4f865997da6216e.png";